import { useState } from "react";

import { useTranslation } from "../i18n";
import AdminPageHeader from "../components/admin-page-header";
import PointsTargetsAdmin from "../components/points/PointsTargetsAdmin";
import PointsLeaderboard from "../components/points/PointsLeaderboard";
import PointsRecordsAdmin from "../components/points/PointsRecordsAdmin";
import PointsGateSettingsAdmin from "../components/points/PointsGateSettingsAdmin";
import "../styles/admin-settings.css";
import "../styles/points-admin.css";

type Tab = "targets" | "leaderboard" | "records" | "settings";

const TAB_LABEL_KEY: Record<Tab, string> = {
    targets: "points_tab_targets",
    leaderboard: "points_tab_leaderboard",
    records: "points_tab_records",
    settings: "points_tab_settings",
};

/**
 * Warehouse > Points.
 *
 * Two halves of one thing: the targets decide what a point costs, the
 * leaderboard shows what people did with them. They used to be four settings
 * sections and nothing, respectively.
 */
const AdminPoints = () => {
    const { t } = useTranslation();
    // Leaderboard first: the numbers are what people come to look at, and
    // targets are set once and then left alone for weeks.
    const [tab, setTab] = useState<Tab>("leaderboard");

    return (
        <div className="page-data page-data-wide" style={{ height: "calc(100vh - 56px)", overflow: "auto" }}>
            <AdminPageHeader
                titleKey="points_settings_title"
                backTo="/admin/warehouse"
                hideSearch
                crumbs={[
                    { labelKey: "admin_panel", to: "/admin" },
                    { labelKey: "warehouse_menu_title", to: "/admin/warehouse" },
                    { labelKey: "points_settings_title" },
                ]}
            />

            <div className="points-admin-tabs" role="tablist">
                {(["targets", "leaderboard", "records", "settings"] as Tab[]).map(key => (
                    <button
                        key={key}
                        type="button"
                        role="tab"
                        aria-selected={tab === key}
                        className={"points-admin-tab" + (tab === key ? " points-admin-tab--active" : "")}
                        onClick={() => setTab(key)}
                    >
                        {t(TAB_LABEL_KEY[key])}
                    </button>
                ))}
            </div>

            <div className="admin-settings-section">
                {tab === "targets"
                    ? <PointsTargetsAdmin />
                    : tab === "records"
                        ? <PointsRecordsAdmin />
                        : tab === "settings"
                            ? <PointsGateSettingsAdmin />
                            : <PointsLeaderboard />}
            </div>
        </div>
    );
};

export default AdminPoints;
